// extracted by mini-css-extract-plugin
module.exports = {"chart":"ProductSales_chart__NAGMv"};